var exports = {
  "KF": "ChessPromotionPicker.module__promotion___OUZlR2",
  "e6": "ChessPromotionPicker.module__promotionLabel___OUZlR2",
  "pc": "ChessPromotionPicker.module__promotionChoice___OUZlR2",
};

module.exports = exports;
